import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12 19.2499C15.866 19.2499 19 16.1159 19 12.2499C19 8.38395 15.866 5.24994 12 5.24994C8.13401 5.24994 5 8.38395 5 12.2499C5 16.1159 8.13401 19.2499 12 19.2499ZM12 16.2499C14.2091 16.2499 16 14.4591 16 12.2499C16 10.0408 14.2091 8.24994 12 8.24994C9.79086 8.24994 8 10.0408 8 12.2499C8 14.4591 9.79086 16.2499 12 16.2499Z"
    fillRule="evenodd"
  />,
  'Point',
)
